import React from 'react';
import { Switch, Route } from 'react-router';
import Globe from './Inputs/GlobeInput';
import Twitter from './Inputs/TwitterAddField';
//import Twitter from './Inputs/TwitterInput';
import Facebook from './Inputs/FacebookInput';
import Instagram from './Inputs/InstagramInput';
import Youtube from './Inputs/YoutubeInput';
import Rss from './Inputs/RssInput';
//import Companies from './Inputs/CompanyInput';

const InputRoutes = (props) => {
    return (
        <Switch>
            <Route exact path="/main/globe" render={() => <Globe {...props} onSubmit={props.onSubmit} loading={props.loading} />} />
            <Route exact path="/main/twitter" component={Twitter} />
            <Route exact path="/main/facebook" component={Facebook} />
            <Route exact path="/main/instagram" component={Instagram} />
            <Route exact path="/main/youtube" component={Youtube} />
            <Route exact path="/main/rss" component={Rss} />
            {/* <Route exact path="/main/companies" component={Companies} /> */}
            <Route exact path="/main/twitter/:id" component={Twitter} />
            <Route exact path="/main/facebook/:id" component={Facebook} />
            <Route exact path="/main/instagram/:id" component={Instagram} />
            <Route path="/main/*" render={() => <Globe {...props} onSubmit={props.onSubmit} />} />
        </Switch>
    );
};

export default InputRoutes;
